import { cn } from '@/helpers/classnames';
import { useStatusOptions } from '@/hooks/useStatusOptions';

export interface StatusInfoProps {
  status: string;
  className?: string;
  visible?: boolean;
  updatedAt?: string;
}

export const StatusInfo = ({
  status,
  className,
  visible = true,
  updatedAt,
}: StatusInfoProps) => {
  const getStatus = useStatusOptions();
  const statusInfo = getStatus({ status });

  if (!visible) return;

  return (
    <div className="flex flex-row items-center gap-2">
      <div
        className={cn(
          'w-fit rounded-full px-3 py-1',
          statusInfo?.style,
          className,
        )}
      >
        {statusInfo?.label}
      </div>
      {updatedAt && <span className="text-sm text-gray-500">{updatedAt}</span>}
    </div>
  );
};
